export default __webpack_public_path__ + "static/media/loadingIcon.027b53fb.png";